/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ maxValue: NonNullable<unknown> }} Fair_Kind_Otter_PlayInputs */

const en_fair_kind_otter_play = /** @type {(inputs: Fair_Kind_Otter_PlayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`To ${i?.maxValue}%`)
};

const de_fair_kind_otter_play = /** @type {(inputs: Fair_Kind_Otter_PlayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bis ${i?.maxValue}%`)
};

/**
* | output |
* | --- |
* | "To {maxValue}%" |
*
* @param {Fair_Kind_Otter_PlayInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const fair_kind_otter_play = /** @type {((inputs: Fair_Kind_Otter_PlayInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fair_Kind_Otter_PlayInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fair_kind_otter_play(inputs)
	return de_fair_kind_otter_play(inputs)
});